<script lang="ts">
    import type { TMappedStaticBlocksConverted } from '$src/lib/services/blocks/types';
    import type { TRouteId } from '$src/generated/routeIds';
    import { get } from 'svelte/store';
    import { page } from '$app/state';
    import { isActiveRoute } from '$src/lib/services/navigation';
    import PageBuilder from '../PageBuilder/PageBuilder.svelte';
    import { afterNavigate } from '$app/navigation';
    import { onMount } from 'svelte';
    import { fetchAndBuildStaticBlocks } from '$src/lib/services/staticBlocks';
    import { GATEKEEPER_VERSION } from '$src/lib/services/gatekeeper/manage-gatekeeper.svelte';

    const {
        data: {
            market: { slug },
            debugMode: debug
        }
    } = page;

    let blocks: TMappedStaticBlocksConverted['blocks'] | null = $state(null);
    let excludedPageGroups: TRouteId[] = $state([]);
    let shouldNotRenderStaticBlocks = $state(true);

    onMount(async () => {
        try {
            const gkFetch = window.fabric.getGatekeeper(
                GATEKEEPER_VERSION as 'v2.2.14',
                'fabric-spine-v2'
            ).fetch;
            ({ blocks, excludedPageGroups } = await fetchAndBuildStaticBlocks(slug, gkFetch, {
                market: page.data.market,
                deviceDetails: page.data.deviceDetails,
                envContext: page.data.envContext
            }));
        } catch (e) {
            console.error('Error during StaticComponents onMount', e);
        }
    });

    $effect(() => {
        //recompute is excludedGroups changes
        shouldNotRenderStaticBlocks = excludedPageGroups?.some((g) => get(isActiveRoute(g)));
    });
    afterNavigate(() => {
        //recompute after each navigation
        shouldNotRenderStaticBlocks = excludedPageGroups?.some((g) => get(isActiveRoute(g)));
    });
</script>

{#if !shouldNotRenderStaticBlocks && blocks}
    <PageBuilder {...blocks.commonBlocks} {debug} />
    {#if page.data.isLoggedIn}
        <PageBuilder {...blocks.lisOnlyBlocks} {debug} />
    {:else}
        <PageBuilder {...blocks.losOnlyBlocks} {debug} />
    {/if}
{/if}
